import "./EditName.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from '../../api/auth';
import Cookies from 'js-cookie';
import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
import { Snackbar, Alert } from '@mui/material';
import Loader from "../Loader";
import { uploadFile } from "../../api/auth";
import { setDashboardActiveComponent } from "../../Redux/Slices/dashboardActiveComponent";
import { useNavigate } from "react-router-dom";
import { getUserId, getToken } from "../../api/index";

function EditName() {
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.userDetails.userDetails);
    const [firstName, setFirstName] = useState(userDetails.firstName);
    const [middleName, setMiddleName] = useState(userDetails.middleName);
    const [lastName, setLastName] = useState(userDetails.lastName);
    const [nickName, setNickName] = useState(userDetails.displayName);
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success' // 'success' | 'error' | 'warning' | 'info'
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            const fileUrl = URL.createObjectURL(file);
            // setPreviewUrl(fileUrl);
            console.log("fileUrl", fileUrl);
            console.log("file", file);
        }
    }

    const handleRemoveFile = () => {
        setSelectedFile(null);
    }

    const handleSubmit = async () => {
        if(isLoading){
            return;
        }
        if(firstName === "" || lastName === ""){
            showSnackbar('First name and last name are required', 'error');
            return;
        }
        setIsLoading(true);
        try {
            const data = await updateUser({
                userId: getUserId(),
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
                displayName: nickName,
            }, getToken());
            if (data) {
                showSnackbar('Profile updated successfully!', 'success');
                dispatch(setUserDetails(data.userDetails));
            }
        } catch (error) {
            console.log("Error:", error);
            showSnackbar('Failed to update profile. Please try again.', 'error');
        }
        setIsLoading(false);
        if (!selectedFile) {
            return;
        }
       try{
        console.log("selectedFile", selectedFile);
        const data = await uploadFile({
            userId: getUserId(),
            file: selectedFile,
        }, getToken());
        
        
        if(data){
            console.log("data", data);
            dispatch(setUserDetails(data.userDetails));
            navigate("/profile-details/request-status");
        }
       }catch(error){
        console.log("Error:", error);
        showSnackbar('Failed to upload file. Please try again.', 'error');
       }
    }
    // console.log("selectedFile", selectedFile);
    return (
        <div className="Feeds">
            <div className="feedsContainer">
                <div className="editNameContainer">
                    <div className="nameContainer">
                        <div className="nameTextContainer">
                            <label className="nameText">First Name</label>
                            <input type='text' className="nameInput" placeholder="Enter your first name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                        </div>
                        <div></div>
                    </div>
                    <div className="nameContainer">
                        <div className="nameTextContainer">
                            <label className="nameText">Middle Name</label>
                            <input type='text' className="nameInput" placeholder="Enter your middle name" value={middleName} onChange={(e) => setMiddleName(e.target.value)} />
                        </div>
                        <div></div>
                    </div>
                    <div className="nameContainer">
                        <div className="nameTextContainer">
                            <label className="nameText">Last Name</label>
                            <input type='text' className="nameInput" placeholder="Enter your last name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        </div>
                        <div></div>
                    </div>
                    <div className="nameContainer">
                        <div className="nameTextContainer">
                            <label className="nameText">Nick Name</label>
                            <input type='text' className="nameInput" placeholder="Enter your nick name" value={nickName} onChange={(e) => setNickName(e.target.value)} />
                        </div>
                        <div></div>
                    </div>
                    {/* <div className="uploadIdContainer">
                        <div className="uploadIdContainerText"><span className="nameValueText">Upload Gov. ID</span></div>

                        <div className="uploadIdContainer2">
                            <div className="uploadIconContainer">
                                <img src='/Assets/EditName/uploadBtn.svg' alt="no-img-found" className="uploadImage" />
                            </div>
                            <label className="uploadIdBtnContainer" style={{ cursor: 'pointer' }}>
                                <input
                                    type="file"
                                    accept=".pdf,image/*"
                                    onChange={handleFileSelect}
                                    style={{ display: 'none' }}
                                />
                                <span
                                    className="uploadIdBtnText"
                                    onClick={(e) => {
                                        if (selectedFile) {
                                            e.preventDefault();
                                            handleRemoveFile();
                                        }
                                    }}
                                >
                                    {selectedFile ? "Remove File" : "Upload file"}
                                </span>
                            </label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span className="bottomText">
                                    {selectedFile ? selectedFile?.name : "only PDF, jpeg file accept."}
                                </span>
                            </div>
                        </div>

                    </div> */}
                    <div className="submitBtnContainer" onClick={handleSubmit}>
                        <button className="btnText" disabled={isLoading}>{isLoading ? <Loader /> : "Update"}</button>
                    </div>
                </div>
                
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert 
                        onClose={handleCloseSnackbar} 
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>

            </div>
        </div>
    )
}

export default EditName;
